/* istanbul ignore file */
import { defineMessages } from 'react-intl'

export default defineMessages({
    requiredError: 'Obligatorio',
    validDate: 'Fecha no válida',
    underAge: 'Debes ser mayor de edad',
})
